export default {
    fund: [{
            "title": "关于投资协议中包含竞业禁止条款的目的，下列表述错误的是（　　）。",
            "question": "A. 保护目标公司商业机密不被泄露\nB. 保障目标公司各方投资人的利益\nC. 保障目标公司利益不受损害\nD. 保证投资人不投资目标公司的竞争方",
            "answer": "D",
            "explain": "本题考查竞业禁止条款的目的。竞业禁止条款是指在投资协议中，股权投资基金为了确保目标公司的良好发展和利益，要求目标公司通过保密协议或其他方式，确保其董事或其他高管不得兼职与本公司业务有竞争的职位，同时，在离职后一段时期内，不得加入与本公司有竞争关系的公司或从事与本公司有竞争关系的业务。A选项说法正确，竞业禁止条款可以通过对目标公司董事或其他高管的约束，保护目标公司商业机密不被董事或其他高管泄露。B、C选项说法正确，竞业禁止条款的目的是为了保证目标公司的利益不受损害，从而保障投资者的利益。D选项说法错误，竞业禁止条款是约束目标公司董事或其他高管，不能保证投资人不投资目标公司的竞争方。"
        },
        {
            "title": "某基金管理人募集股权投资基金时，不符合募集行为规定的是（　　）。",
            "question": "A. 通过电子邮件向特定的机构投资者发送募集说明书\nB. 通过拆分基金份额向特定投资者销售基金\nC. 通过银行向部分高净值客户推荐基金\nD. 向其管理的其他基金的投资者推荐该基金",
            "answer": "B",
            "explain": "本题考查募集行为管理。股权投资基金应当向合格投资者募集，单位或个人不得为规避合格投资者标准，募集以股权投资基金份额或其收益权为投资标的的金融产品，或者将股权投资基金份额或其收益权进行非法拆分转让，变相突破合格投资者标准。B选项中拆分基金份额不符合募集行为规定，符合题意。此题中的特定机构投资者，部分高净值客户和其他基金的投资者均属于合格投资者，可以向其推荐基金。A、C、D符合募集行为规定，不符合题意。"
        },
        {
            "title": "如果没有（　　），创始人股东可以做以下事情：发行巨量股份给创始人，将投资人股份比例稀释成接近零。",
            "question": "A. 保护性条款\nB. 回售条款\nC. 优先认购权条款\nD. 反摊薄条款",
            "answer": "A",
            "explain": "本题考查保护性条款。保护性条款是股权投资基金为保护自身利益而设置的要求目标公司在执行某些可能损害投资者利益或对投资者利益有重大影响的行为时，需取得投资者同意的条款。在创业投资中，创业投资基金通常是被投资企业的小股东，因此会向企业家要求设置保护性条款，设立保护性条款的目的是保护作为小股东的投资者，防止其利益受到大股东侵害。保护性条款针对的通常是涉及投资者经济利益或者公司控制权的重大事项。"
        },
        {
            "title": "股权投资基金模拟对某目标公司进行法律尽职调查，法律尽职调查需关注的高级管理人员问题包括（　　）。",
            "questions": "I. 目标公司的首席技术官是否与目标公司签订协议，限制其离职后开展与公司类似的业务<br>II. 目标公司的总经理薪酬高于同业50%<br>III. 目标公司的前任CFO不满被公司开除，目前正与公司进行劳动仲裁，要求12个月的工资作为赔偿<br>IV. 目标公司尚未针对高级管理人员建立股权激励机制",
            "question": "A. I、IV\nB. III、IV\nC. I、II、III\nD. I、III",
            "answer": "D",
            "explain": "本题考查法律尽职调查。法律尽职调查需关注的高级管理人员问题包括：(1)高级管理人员是否与企业签订了应有的劳动合同，是否存在劳动仲裁或纠纷情况（III项）。"
        },
        {
            "title": "根据有关规定，（　　）应及时编制并对外提供真实、完整的基金财务会计报告。",
            "question": "A. 股权投资基金托管人\nB. 股权投资基金审计机构\nC. 股权投资基金管理人\nD. 股权投资基金有限合伙人",
            "answer": "C",
            "explain": "本题考查基金财务报告。根据有关规定，股权投资基金管理人应及时编制并对外提供真实、完整的基金财务会计报告。"
        },
        {
            "title": "私募基金募集完毕，私募基金管理人应当根据中国证券投资基金业协会的规定，办理基金备案手续时应当提交的材料的是（　　）。",
            "question": "A. 私募基金的基金合同、公司章程或者合伙协议\nB. 私募基金的类别\nC. 私募基金的主要投资方向\nD. 私募基金的发售公告",
            "answer": "D",
            "explain": "本题考查基金备案的内容。各类股权投资基金募集完毕，基金管理人进行基金备案，通常应向基金业协会报送以下材料或信息：(1)主要投资方向及根据主要投资方向注明的基金类别（B、C选项）。(2)基金合同、公司章程或者合伙协议。资金募集过程中向投资者提供基金招募说明书的，应当报送基金招募说明书。以公司、合伙等企业形式设立的股权投资基金，还应当报送工商登记和营业执照正副本复印件（A选项）。"
        }, {
            "title": "以下关于股权投资基金托管的表述正确的是（　　）。",
            "question": "A. 股权投资基金必须进行托管\nB. 目前投资基金的托管人只能由商业银行担任\nC. 股权投资基金托管人是基金管理人的代理人\nD. 召集基金份额持有人大会是股权投资基金托管人的重要职责",
            "answer": "D",
            "explain": "本题考查基金托管服务。A选项说法错误，除基金合同另有约定外，基金财产应当由基金托管人托管。基金合同约定股权投资基金不进行托管的，股权投资基金管理人应建立保障股权投资基金财产安全的制度措施和纠纷解决机制。B选项说法错误，D选项说法正确，股权投资基金托管是指具有托管业务资格的商业银行或者其他金融机构担任托管人，按照法律法规的规定及基金合同或托管协议的约定，对基金履行安全保管财产、开设基金资金账户、办理清算交割、复核审查资产净值、开展投资监督、召集基金份额持有人大会等职责的行为。"
        },
        {
            "title": "假设股权投资基金正在对某目标公司进行财务尽职调查，进行偿债能力分析时，以下内容属于应主要关注的财务指标或数据的是（　　）。",
            "questions": "I. 流动比率<br>II. 或有负债<br>III. 资产周转率<br>IV. 银行可用授信额度<br>V. 现金流量状况",
            "question": "A. I、II、IV\nB. II、III、IV\nC. I、II、III、IV\nD. I、II、IV、V",
            "answer": "D",
            "explain": "本题考查财务尽职调查的偿债能力分析。偿债能力分析包括计算公司各年度资产负债率、流动比率（I项）、速动比率、利息保障倍数等，结合公司的现金流量状况（V项），在银行的资信等级。"
        },
        {
            "title": "某股权投资基金与其所投资的企业因规范管理问题发生了争议，计划起诉所投资的企业，以下不能作为起诉主体的是（　　）。",
            "question": "A. 信托(契约)型基金\nB. 合伙型基金\nC. 基金管理人\nD. 公司型基金",
            "answer": "A",
            "explain": "本题考查不同组织形式的主体。诉讼主体就是可以作为原告、被告或者第三人参与诉讼的自然人、法人或者其他组织。A选项，信托（契约）型基金本质是一种信托关系，不能作为起诉主体。B选项，合伙型基金是非法人企业，属于组织，可以作为起诉主体。C选项，基金管理人应当为依法设立的公司或企业，可以作为起诉主体。"
        },
        {
            "title": "股权投资基金投资者的以下税负涉及代扣代缴事项的是（　　）。",
            "questions": "I. 个人投资者从公司型基金获得的股息红利形式的分配<br>II. 公司型投资者从公司型基金获得的股息红利形式的分配<br>III. 公司型投资者从合伙型基金获得的已分配所得<br>IV. 自然人投资者从合伙型基金暂未实际分配的当年应税所得",
            "question": "A. I\nB. I、II\nC. III、IV\nD. I、IV",
            "answer": "D",
            "explain": "本题考查股权投资基金的基本税负。I需要代扣代缴，个人投资者从公司型基金获得的股息红利形式的分配需缴纳股息红利所得税（适用税率为20%）并由基金代扣代缴。II不需要缴税，公司型投资者从公司型基金获得的股息红利形式的分配按照《企业所得税法》的规定免税。"
        },
        {
            "title": "以下属于公司型股权投资基金需要缴纳所得税的收入是（　　）。",
            "questions": "I. 接受捐赠的收入<br>II. 转让财产的收入<br>III. 股息红利的投资收益<br>IV. 接受投资的收入",
            "question": "A. II、III\nB. I、III\nC. I、II、III\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查公司型基金所得税缴纳。《企业所得税法》第六条规定，企业所得税收入总额包括销售货物收入、提供劳务收入、转让财产收入（II项）、股息、红利等权益性投资收益（III项）和利息收入、租金收入、特许权使用费收入、接受捐赠收入（I项）、其他收入。IV项，接受投资收入不算收入，算实收资本。"
        },
        {
            "title": "关于未上市企业股权的非公开协议转让，以下表述正确的是（　　）。",
            "question": "A. 除公司章程另有约定外，股份有限公司只能对内部转让股权\nB. 并购退出、回购退出和清算退出都是协议转让退出的主要方式\nC. 有限责任公司股权的外部转让，除公司章程另有约定外，需经全部其他股东同意\nD. 员工收购（EBO）是回购退出的一种方式",
            "answer": "D",
            "explain": "本题考查协议转让退出内容。A选项说法错误，根据受让人的不同，转让可以分成内部转让和外部转让。股份有限公司属于资合性公司，股份转让受到的限制相对较少，但内部治理更加规范及严格。B选项说法错误，协议转让退出包括并购退出和回购退出，不包括清算退出。C选项说法错误，有限责任公司有一定的人合性特征，股东之间可以相互转让其持有的股权，但对外转让一般需经其他股东过半数同意，且其他股东有优先受让权。"
        }, {
            "title": "股权投资基金存在由委托代理关系中信息不对称导致的代理风险，还具有流动性低、风险性较高、杠杆率较高等特点。鉴于上述情况，股权投资基金监管的目标主要包括（　　）。",
            "questions": "I. 保护基金投资者合法权益<br>II. 维护一级市场交易秩序<br>III. 防范系统性金融风险<br>IV. 最大化监管效率",
            "question": "A. I、II、IV\nB. I、III\nC. II、III\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查股权投资基金监管的目标。股权投资基金监管的目标包括保护基金投资者合法权益和防范系统性金融风险。"
        },
        {
            "title": "股权投资基金托管人是基金重要的当事人之一，作为基金托管人的基础服务和重要职责是（　　）。",
            "question": "A. 账户管理\nB. 资金清算\nC. 资产保管\nD. 投资监督",
            "answer": "C",
            "explain": "本题考查基金托管的服务内容。资产保管是股权投资基金托管的基础服务，也是托管人的首要职责，基金托管人应当按规定独立、完整、安全地保管所托管基金的财产，保证基金财产的安全完整。"
        },
        {
            "title": "关于合伙型基金，表述正确的是（　　）。",
            "question": "A. 基金是独立企业，应缴纳企业所得税\nB. 有限合伙人通常以投资决策委员会成员参与投资决策\nC. 普通合伙人可以通过自我管理或者委托其他基金管理人负责基金投资等重大事项的管理与决策\nD. 主要参与主体有合伙人、基金管理人以及基金托管人",
            "answer": "C",
            "explain": "本题考查合伙型基金内容。A选项说法错误，按照我国税法，有限合伙企业不是企业所得税的纳税主体，而是由合伙人承担纳税义务。B选项说法错误，有限合伙人不参与投资决策，不执行合伙事务，对外不可以代表合伙企业。C选项说法正确，普通合伙人可自行担任基金管理人或者委托专业的基金管理机构担任基金管理人，负责基金投资等重大事项的管理与决策。"
        },
        {
            "title": "某有限合伙型股权投资基金的有限合伙人为甲，基金管理人为乙，基金托管人为丙，根据中国证券投资基金业协会的自律规则，该基金的信息披露义务人为（　　）。",
            "question": "A. 甲和乙\nB. 甲和丙\nC. 乙和丙\nD. 仅有乙",
            "answer": "C",
            "explain": "本题考查信息披露义务人。信息披露义务人是指股权投资基金管理人（乙）、股权投资基金托管人（丙），以及法律、行政法规、中国证监会和中国证券投资基金业协会规定的负有信息披露义务的法人和其他组织。有限合伙人不参与投资决策，不执行合伙事务，对外不可以代表合伙企业，没有信息披露义务。"
        },
        {
            "title": "下列属于股权投资基金募集行为的是（　　）。",
            "questions": "I. 拟定推荐材料<br>II. 考虑募集渠道<br>III. 确定募集对象<br>IV. 发售基金份额",
            "question": "A. II、III、IV\nB. II、IV\nC. I、II、III\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查股权投资基金募集行为的主要内容。股权投资基金的募集是指股权投资基金管理人或者受其委托的募集服务机构向投资者募集资金用于设立股权投资基金的行为。具体而言，募集行为包括推介基金（拟定推荐材料、考虑募集渠道、确定募集对象）、发售基金份额、办理投资者认/申购（认缴）、份额登记、赎回（退出）等活动。"
        },
        {
            "title": "尽职调查中获得的公司信息，对投资方的作用包括（　　）。",
            "questions": "I. 帮助投资方对投资协议中的交易条款进行取舍<br>II. 帮助投资方在未来同行业投资标的谈判中，以其获得的非公开信息争取投资机会<br>III. 帮助投资方评估后管理所需投入的资源和成本，提高投资决策的质量<br>IV. 帮助投资方对项目未来退出的可行性大小和成本高低进行评估",
            "question": "A. I、II、IV\nB. I、III、IV\nC. I、II、III\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查尽职调查的作用。尽职调查中获得的公司信息可以帮助投资方在投资条款谈判（I项）、投资后管理重点内容（III项）、项目退出方式选择（IV项）等方面提供依据。"
        }, {
            "title": "申请股权投资基金管理人登记的机构，（　　）可不纳入《私募基金管理人登记法律意见书》。",
            "question": "A. 从业人员是否全部具备基金从业资格\nB. 是否存在境外股东\nC. 私募基金管理人名称中是否含有“私募”相关字样\nD. 是否存在分支机构",
            "answer": "A",
            "explain": "本题考查法律意见书的内容。法律意见书的内容包括：（1）申请机构是否依法在中国境内设立并有效存续。（2）申请机构的工商登记文件所记载的经营范围是否符合国家相关法律法规的规定。申请机构的名称和经营范围中是否含有“基金管理”“投资管理”“资产管理”“股权投资”“创业投资”等与基金管理人业务属性密切相关的字样；以及私募基金管理人名称中是否含有“私募”相关字样。（C选项需纳入）"
        },
        {
            "title": "股权投资基金监管活动不仅要以价值最大化的方式实现基金监管的根本目标，而且还要通过监管活动促进股权投资基金行业的持续健康规范发展。上述描述体现了股权投资基金的（　　）原则。",
            "question": "A. 高效监管\nB. 审慎监管\nC. 分类监管\nD. 适度监管",
            "answer": "A",
            "explain": "股权投资基金监管的基本原则包括：（1）依法监管原则：是指监管机构的设置及其监管职权的取得，必须有法律依据；监管职权的行使，必须依据法律程序，既不能超越法律的授权滥用权力，也不能怠于行使法定的职责；对违法行为的制裁，必须依据法律的明确规定，秉公执法，不偏不倚。（2）高效监管原则：是指股权投资基金监管活动不仅要以价值最大化的方式实现基金监管的根本目标，而且还要通过监管活动促进股权投资基金行业的持续健康规范发展。"
        },
        {
            "title": "关于股权投资基金所投资的公司发生解散清算和破产清算情况，以下表述错误的是（　　）。",
            "question": "A. 通过破产清算方式退出的，股东收回全部投资的可能性极小，股权投资基金可能损失全部投资\nB. 公司解散清算的，股权投资基金作为有限责任公司股东，可以任为清算组的成员\nC. 公司依法被吊销营业执照、责令关闭或者被撤销的，应当进行解散清算\nD. 公司财产不足清偿债务的，清算组应向仲裁委员会提出申请，进行破产清算",
            "answer": "D",
            "explain": "本题考查清算退出内容。A选项说法正确，通过破产清算方式退出的，股东收回全部投资的可能性极小，一般情况下甚至会损失全部投资。B选项说法正确，有限责任公司的清算组由股东组成。公司解散清算的，股权投资基金作为有限责任公司股东，可以任为清算组的成员。C选项说法正确，根据《公司法》的规定，出现公司依法被吊销营业执照、责令关闭或者被撤销情形，公司应当进行解散清算。D选项说法错误，公司资产不足清偿债务的，应立即向人民法院申请宣告破产。"
        },
        {
            "title": "某股权投资基金管理公司在中国证券投资基金业协会进行基金管理人登记出具专项法律意见书时，管理机构的境外股东律师应该核查（　　）。",
            "questions": "I. 直接控股的境外股东<br>II. 直接参股的境外股东<br>III. 间接控股的境外股东<br>IV. 间接参股的境外股东",
            "question": "A. I、II\nB. I、II、III、IV\nC. III、IV\nD. II、III",
            "answer": "B",
            "explain": "本题考查法律意见书中律师应重点核查的内容。关于管理机构的境外股东，出具法律意见书时，律师应重点核查的内容包括：（1）申请机构是否有直接或间接控股或参股的境外股东；"
        },
        {
            "title": "信托（契约）型股权投资基金的申购、赎回和登记操作，负责办理机构为（　　）。",
            "question": "A. 中国证券投资基金业协会\nB. 证券登记结算中心\nC. 基金托管人\nD. 基金管理人或其委托的登记机构",
            "answer": "D",
            "explain": "本题考查基金份额登记机构。基金管理人可以办理其募集基金的份额登记业务，也可以委托基金份额登记机构代为办理基金份额登记业务。在后一种情况下，由股权投资基金份额登记机构提供基金份额的登记、过户、保管和结算等服务。即基金管理人或其委托的登记机构负责办理信托（契约）型股权投资基金的申购、赎回和登记操作。"
        },
        {
            "title": "关于回售权条款，下列表述错误的是（　　）。",
            "question": "A. 在约定的触发条件发生时，回售权条款可以保证基金从创始股东获得更多股份，以优惠的价格进一步追加投资来提高潜在回报\nB. 在约定的触发条件发生时，回售权条款可以保障基金的投资具有一定流动性\nC. 回售权条款的触发条件除了业绩指标触发条件，也包括非业绩事件触发条件\nD. 基金可以通过行使回售权达到估值调整的作用",
            "answer": "A",
            "explain": "本题考查回售权条款。A选项说法错误，回售权是指满足协议约定的特定触发条件时，股权投资基金有权将其持有的全部或部分目标公司股份回售给目标公司创始股东或创始股东指定的其他相关利益方。（而不是从创始股东获得更多股份）B、D选项说法正确，回售权条款的功能包括：（1）通过行使回售权达到估值调整的目的；"
        }, {
            "title": "企业上市后股权锁定期设置的目的在于（　　）。",
            "question": "A. 发行企业主动提升投资者信心\nB. 提高退出实现的收益率水平\nC. 保护中小投资者\nD. 提高退出节奏的计划性",
            "answer": "C",
            "explain": "本题考查对于企业上市设置锁定期的目的。A选项不符合题意，锁定期分为强制锁定和自愿锁定。强制锁定是指法律法规或交易所规则规定的关于股份锁定的规则。例如，我国《公司法》规定，公司公开发行股份前已经发行的股份，自公司股票在证券交易所上市交易之日起一年内不得转让。自愿锁定是指在强制锁定的基础上，为了提升投资者信心，公司实际控制人、控股股东、董事、监事或高管自愿承诺在一定时间内不对外转让其持有的上市公司股份。A选项只是自愿锁定的目的。"
        },
        {
            "title": "股权投资基金管理人跟投其所管理基金的投资项目，所形成的权益（　　）。",
            "question": "A. 不属于基金管理人固有财产，但是属于基金财产\nB. 属于基金管理人固有财产，但不属于基金财产\nC. 既不属于基金管理人固有财产，也不属于基金财产\nD. 属于基金管理人固有财产，同时也属于基金财产",
            "answer": "B",
            "explain": "本题考查管理人内部控制的独立性原则。私募基金管理人及其从业人员跟投项目，其所形成的权益仍为基金管理人及其从业人员固有财产，不属于基金财产。"
        },
        {
            "title": "某全国中小企业股份转让系统股票投资者委托主办券商按每股15元每股的价格购买A股票数量不超过10000股，委托方式属于（　　）。",
            "question": "A. 竞价委托\nB. 定价委托\nC. 成交确认委托\nD. 定量委托",
            "answer": "B",
            "explain": "本题考查定价委托的概念。A、D选项排除，全国股转系统排牌后的退出方式包括协议转让和做市转让，委托方式没有竞价委托和定量委托。全国股转系统排牌后的退出方式中，协议转让包括：（1）定价委托：指投资者委托主办券商设定股票价格和数量，但没有确定的交易对手方，交易信息将公开显示于交易大盘中；（2）成交确认委托：指买卖双方达成成交协议，委托主办券商向指定对手方发出确认成交的指令。"
        },
        {
            "title": "基金销售机构参与股权投资基金募集活动的必备条件不包括（　　）。",
            "question": "A. 接受基金管理人的委托\nB. 在中国证监会注册并取得基金销售资格\nC. 销售机构的实缴注册资本最低为1000万元\nD. 成为中国证券投资基金业协会会员",
            "answer": "C",
            "explain": "本题考查基金的委托募集。委托募集指基金管理人委托有资格的第三方基金销售机构为其设立的股权投资基金募集资金。故A选项为必备条件，不符合题意。目前，我国要求代销机构应获得中国证监会基金销售业务资格且成为中国证券投资基金业协会会员。故B、D选项为必备条件，不符合题意。C选项基金销售机构商业银行、证券公司、独立基金销售机构等，注册资本要求各不相同。"
        },
        {
            "title": "关于中国证监会对申请境外直接上市企业的要求，以下表述错误的是（　　）。",
            "question": "A. 具有规范的法人治理结构及较完善的内部管理制度\nB. 筹资用途符合国家产业政策、利用外资政策及国家有关固定资产投资立项的规定\nC. 净资产不低于4亿元人民币\nD. 过去一年税后利润不少于5000万人民币，并有增长潜力；按照合理市盈率预期，筹资不少于6000万美元",
            "answer": "D",
            "explain": "本题考查中国证监会对申请境外直接上市企业的要求。我国企业选择境外直接上市，需首先向中国证监会提出申请。为保证上市公司质量，中国证监会对企业申请境外上市提出了较高的要求。中国证监会《关于企业申请境外上市有关问题的通知》中的“四五六条款”对申请境外直接上市企业的财务状况提出了较为严格的要求，具体包括拟上市企业筹资用途符合国家产业政策、利用外资政策及国家有关固定资产投资立项的规定，净资产不少于4亿元人民币；过去一年税后利润不少于6000万元人民币，并有增长潜力；按照合理市盈率预期，筹资额不少于5000万美元；具有规范的法人治理结构及较完善的内部管理制度；有较稳定的高级管理层及较高的管理水平；等等。"
        },
        {
            "title": "关于信托（契约）型基金的特点，以下表述正确的是（　　）。",
            "questions": "I. 信托（契约）型基金本质是信托关系，契约各方通过订立信托契约进行相关约定<br>II. 信托（契约）型基金不具有法人主体地位，因此不需要纳税<br>III. 信托（契约）型基金的投资者，需对取得的投资收益缴纳所得税<br>IV. 信托（契约）型基金的投资者以其出资为限，对基金的债务承担有限责任",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、III、IV",
            "answer": "D",
            "explain": "本题考查信托（契约）型基金的特点。I项说法正确。信托（契约）型基金本质上是一种信托关系，因此，契约各方可通过信托契约进行相关约定，运作比较灵活。II项说法错误，III项说法正确，信托（契约）型基金不是企业所得税的纳税主体，不需要缴纳所得税，只有基金投资者需要对取得的投资收益缴纳所得税。"
        }, {
            "title": "关于投资协议(投资备忘录)中的排他性条款，以下说法正确的是（　　）。",
            "questions": "I. 排他性条款通常没有时间限制<br>II. 排他性条款一般会约定一个为期几个月的排他周期<br>III. 排他性条款赋予了股权投资基金对一些特定重大事项的一票否决权<br>IV. 投资方如在协议签署之日前的任何时间决定不执行该投资计划，应立即通知目标企业",
            "question": "A. II、III\nB. II、III、IV\nC. I、III、IV\nD. II、IV",
            "answer": "D",
            "explain": "本题考查排他性条款。排他性条款要求目标公司现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。"
        },
        {
            "title": "股权投资基金进行业务尽职调查的主要目的是（　　）。",
            "question": "A. 关注主要股东与目标公司之间的关联交易是否合法\nB. 评估企业资产和业务的合法性及潜在法律风险\nC. 调查公司及控股子公司历史财务数据\nD. 了解过去及现在企业创造价值的机制及变化趋势",
            "answer": "D",
            "explain": "本题考查业务尽职调查的主要目的。业务尽职调查是整个尽职调查工作的核心，目的是了解过去及现在企业创造价值的机制，以及这种机制未来的变化趋势。"
        },
        {
            "title": "在设计和执行基金管理人内部控制制度时，下列表述正确的是（　　）。",
            "question": "A. 设置较多环节，提高控制效果\nB. 根据领导要求，灵活执行内部控制制度\nC. 将非核心业务外包给中介机构，免除自身责任\nD. 重要业务部门和岗位进行物理隔离，增强独立性",
            "answer": "D",
            "explain": "本题考查管理人内部控制的内容。A选项表述错误，管理人内部控制的成本效益原则是指以合理的成本控制达到最佳的内部控制效果，内部控制与股权投资基金管理人的管理规模和员工人数等方面相匹配，契合自身实际情况，而不是设置较多环节。B选项表述错误，管理人内部控制的适时性原则是指股权投资基金管理人应当定期评价内部控制的有效性，并随着有关法律法规的调整和经营战略、方针、理念等内外部环境的变化同步适时修改或完善，而不是根据领导要求。C选项说法错误，股权投资基金管理人委托服务机构提供基金服务的，股权投资基金管理人依法应当承担的责任不因委托而免除。"
        },
        {
            "title": "股权投资基金A、股权投资基金B分别持有目标公司甲的股份10%和15%，其余股份均为公司创始人持有。目标公司甲拟通过增发500股融资1000万元用于拓展线下直营店。股权投资基金C有意向认购，创始人及股权投资基金B表示放弃优先认购权，股权投资基金A行使优先认购权，则股权投资基金C可以认购的股份数量以及对应的投资额分别为（　　）。",
            "question": "A. 450股，900万元\nB. 375股，750万元\nC. 225股，450万元\nD. 400股，800万元",
            "answer": "A",
            "explain": "本题考查优先认购权条款。优先认购权是指目标公司未来发行新的股份或者可转换债券时，股权投资基金将按其持股比例获得同等条件下的优先认购权利。股权投资基金A持股比例为10%，可认购股份数量=500x10%=50(股)，投资额=1000x10%=100(万元)。股权投资基金C可认购股份数量=500-50=450(股)，投资额=1000-100=900(万元)。"
        },
        {
            "title": "股权投资基金投资目标公司股权时，投融资双方谈判后最终签署的约定双方权利义务关系的文本是（　　）。",
            "question": "A. 基金合同\nB. 投资协议\nC. 合伙协议\nD. 投资条款清单",
            "answer": "B",
            "explain": "本题考查投资协议的内容。B选项符合题意，股权投资基金投资目标公司股权时，投融资双方谈判后最终签署的约定双方权利义务关系的文本是投资协议。"
        },
        {
            "title": "关于保护性条款，以下表述正确的是（　　）。",
            "question": "A. 保护性条款本质上是一种价格保护机制\nB. 设立保护性条款的目的是保护作为大股东的投资者\nC. 设立保护性条款的目的是保护目标公司与企业家\nD. 保护性条款通常针对涉及投资者经济利益或公司控制权的重大事项",
            "answer": "D",
            "explain": "本题考查保护性条款的内容。保护性条款是指股权投资基金为保护自身利益而设置的要求目标公司在执行某些可能损害投资者利益或对投资者利益有重大影响的行为时，需取得投资者同意的条款。A选项说法错误，反摊薄条款也称为反稀释条款，本质上是一种价格保护机制。B、C选项说法错误，在创业投资中，创业投资基金通常是被投资企业的小股东，因此会向企业家要求设置保护性条款，设立保护性条款的目的是保护作为小股东的投资者，防止其利益受到大股东侵害。"
        }, {
            "title": "某合伙型股权投资基金的基金合同中包含如下条款，其中不符合中国证券投资基金业协会相关基金合同要求的是（　　）。",
            "question": "A. 本基金由普通合伙人担任执行事务合伙人，执行事务合伙人有权对合伙企业的财产进行投资、管理、运用和处置，并接受其他普通合伙人和有限合伙人的监督\nB. 本基金的财产份额不得以任何方式公开募集或发行\nC. 本基金解散清算时首先应对基金合伙人进行分配，如有剩余，则可用于支付基金清算费用\nD. 本基金为有限合伙企业形式，仅有一名普通合伙人",
            "answer": "C",
            "explain": "本题考查合伙型基金。A选项符合要求，合伙型股权投资基金合伙协议应约定由普通合伙人担任执行事务合伙人。执行事务合伙人有权对合伙企业的财产进行投资、管理、运用和处置，并接受其他普通合伙人和有限合伙人的监督。B选项符合要求，我国股权投资基金只能非公开募集。"
        },
        {
            "title": "股权投资基金的形式可分为公司型、合伙型和信托(契约)型三种组织形式，关于基金组织形式及其投资决策描述正确的是（　　）。",
            "question": "A. 公司型基金的最高权力机构是董事会，公司型基金的投资者可以通过参加公司型基金的董事会参与基金的运营决策\nB. 合伙型基金的投资者一般以有限合伙人身份存在，有限合伙人可通过在投资决策委员会委派观察员或在咨询委员会中委派委员等方式，在一定程度上了解基金的投资决策并在合理的范围内提供建议\nC. 信托(契约)型基金的基金份额持有人大会及其日常机构可以直接参与或者干涉基金的投资管理活动\nD. 公司型基金可由公司内部的基金管理运营团队进行管理，通常的形式是在股东会之下设置投资决策委员会，其成员一般由股东会委派",
            "answer": "B",
            "explain": "本题考查基金内部组织机构的设置与投资决策。A选项说法错误，公司型基金的最高权力机构是股东(大)会，在公司型基金中投资者权利较大，在股东大会(股东会)层面对交由决策的重大事项或重大投资进行决策。B选项说法正确，合伙型基金的投资者以有限合伙人身份存在，有限合伙人可通过在投资决策委员会委派观察员或在合伙人会议委派委员等方式，在一定程度上了解基金的投资决策并在合理的范围内提供建议。"
        },
        {
            "title": "企业价值与股权价值之间转换时，会运用到简单价值的等式。等式中的“债务”不包括（　　）。",
            "question": "A. 短期银行贷款\nB. 应付账款\nC. 公司付息贷款\nD. 长期银行贷款",
            "answer": "B",
            "explain": "本题考查简单价值等式。简单价值等式为:企业价值+现金=股权价值+债务。简单价值等式中，“债务”与资产负债表中的负债不同，只包括要支付利息的负债(如银行贷款)，不包括不用支付利息的负债(如应付账款)。"
        },
        {
            "title": "关于中国企业境外直接上市，以下表述错误的是（　　）。",
            "question": "A. 境外直接上市的优点在于可直接进入境外资本市场，提升企业国际知名度和影响力\nB. 我国企业境外直接上市，可获得外汇资金\nC. 我国企业境外直接上市，需要向中国证监会提出申请\nD. 我国企业境外直接上市也包括通过境外特殊目的公司的名义申请境外交易所上市交易",
            "answer": "D",
            "explain": "本题考查境外直接上市。境外直接上市的优点在于可直接进入境外资本市场，节省信息传递成本，极大地提升企业国际知名度和影响力，并获得外汇资金。我国企业选择境外直接上市，需首先向中国证监会提出申请。故D选项错误，D选项属于境外间接上市。"
        },
        {
            "title": "股权投资基金限对目标公司进行财务尽职调查，以下表述错误的是（　　）。",
            "question": "A. 财务尽职调查有与审计同样的重要意义，强调发现目标公司财务收支和会计资料的真实、正确\nB. 财务尽职调查的分析经常会用到场景分析和敏感度分析等方法\nC. 基金的财务尽职调查团队应收集目标公司相关的财务报告进行分析，重点考查目标公司的现金流、盈利及资产事项\nD. 财产尽职调查应涵盖目标公司的历史经营业绩，未来盈利预测等内容",
            "answer": "A",
            "explain": "本题考查财务尽职调查。A选项说法错误，不同于审计，财务尽职调查强调发现企业的投资价值和潜在风险，注重对企业未来价值和成长性的合理预测。B选项说法正确，财务尽职调查经常采用趋势分析和结构分析工具，在财务预测中经常会用到场景分析和敏感度分析等方法。C选项说法正确，财务尽职调查团队应收集目标公司相关的财务报告及相关支持材料，了解其会计政策及相关会计假设，进行财务比率分析，考查企业的现金流、盈利及资产事项。"
        },
        {
            "title": "股权投资基金的项目退出是整个投资的关键环节，以下表述错误的是（　　）。",
            "question": "A. 股权投资基金选择在合适的时机，将被投资企业的股权变现，获得现金收益，实现项目退出\nB. 项目退出的目的是为了实现资本增值，或及时避免和降低损失\nC. 股权投资的最终目标是实现项目的成功退出\nD. 项目退出的目的是股权投资基金将被投企业的经营和管理权交还于原企业创始团队",
            "answer": "D",
            "explain": "本题考查项目退出的概念。A、B选项说法正确，D选项说法错误，股权投资基金的项目退出，是指股权投资基金选择合适的时机，将其在被投资企业的股权变现，由股权形态转化为具有流动性的现金收益，以实现资本增值，或及时避免和降低财产损失。C选项表述正确，对股权投资基金而言，实现项目的成功退出是其进行股权投资的最终目标。"
        }, {
            "title": "股权投资基金X投资的Y企业已进入破产清算程序，X在Y企业中的持股比例为10%，Y的账面资产总值8亿元，负债、利息和相关清算费用合计7.5亿元，经法院拍卖资产，资产变现总值为12亿元，则X基金持有Y企业的股权估值为（　　）。",
            "question": "A. 0.45亿元\nB. 0.75亿元\nC. 0.9亿元\nD. 1.5亿元",
            "answer": "A",
            "explain": "本题考查清算价值法。清算价值法常见于杠杆收购和破产投资策略。Y企业已进入破产清算程序，适用清算价值法计算股权价值。计算公司股权价值=资产变现总值-负债、利息和清算费用合计，已知资产变现总值为12亿元，负债、利息和相关清算费用合计7.5亿元，代入公式：公司股权价值=12-7.5=4.5（亿元）。计算X基金持有Y企业的股权=公司股权价值×持股比例，已知X在Y企业中的持股比例为10%，X基金持有Y企业的股权=4.5×10%=0.45（亿元）。"
        },
        {
            "title": "关于股权投资基金管理人的内部控制，表述正确的是（　　）。",
            "questions": "I. 股权基金管理人开展业务外包应制定相应的风险管理框架及制度<br>II. 投资决策应符合合同所约定的预期收益、投资范围、投资策略<br>III. 所有基金都应当由基金托管人进行托管<br>IV. 管理人选择基金服务机构时，应关注该服务机构是否存在与基金服务业务相冲突的其他业务",
            "question": "A. II、III\nB. II、IV\nC. I、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查管理人内部控制的主要控制活动要求。立项表述错误，基金合同不能约定预期收益，重项表述错误，除基金合同另有约定外，基金财产应当由基金托管人托管，股权投资基金管理人应建立健全股权投资基金托管人遴选制度，切实保障资金安全。基金合同约定股权投资基金不进行托管的，股权投资基金管理人应建立保障股权投资基金财产安全的制度地点和纠纷解决机制。"
        },
        {
            "title": "关于管理人内部控制说法，正确的是（　　）。",
            "question": "A. 管理人在基金到期时，将基金未退出项目收购\nB. 在进行岗位设置时，需考虑纵向控制的制约关系，以使下级受上级监督，上级受下级专制\nC. 内部控制需涵盖投资研究、运行保障等主要环节，不需要涵盖资金募集环节\nD. 管理人破产清算时，需要将其管理的基金财产纳入其资产范围进行统一清算",
            "answer": "B",
            "explain": "本题考查管理人内部控制的原则。管理人内部控制的原则包括：(1) 全面性原则 (2) 相互制约原则 (3) 执行有效原则。"
        },
        {
            "title": "股权投资基金运作股权投资业务取得的不同形态资本增值中，需要计缴增值税的是（　　）。",
            "question": "A. 项目股息、分红收入\nB. 通过回购方式退出的项目收入\nC. 通过并购退出的项目收入\nD. 通过二级市场退出的项目收入",
            "answer": "D",
            "explain": "本题考查股权投资基金的增值税。股权投资基金运作股权投资业务取得不同形态的资本增值中：(1) 项目股息、分红收入（属于股息红利所得）；不征收增值税（A选项不需要）；(2) 项目通过并购或回购等非上市股权转让方式退出不征收增值税（B、C选项不需要）。"
        },
        {
            "title": "关于增值税，以下表述正确的是（　　）。",
            "questions": "I. 增值税属于流转税<br>II. 金融业尚未全面纳入营改增试点范围<br>III. 转让非上市公司股权无需缴纳增值税<br>IV. 项目上市后通过二级市场退出免征增值税",
            "question": "A. I、III\nB. II、IV\nC. I、II\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查增值税。I项说法正确，增值税属于流转税。"
        },
        {
            "title": "关于内部收益率（IRR），下列说法错误的是（　　）。",
            "question": "A. 内部收益率（IRR）是反映投资基金获利能力的动态财务指标\nB. 基金内部收益率（IRR）可以为投资人评价基金的投资效果提供参考\nC. 基金内部收益率（IRR）指标可以用来对不同基金的业绩进行评价\nD. 基金某一时点的内部收益率（IRR）与基金存续期满清算后的内部收益率是相同的",
            "answer": "D",
            "explain": "本题考查内部收益率的相关内容。A选项说法正确，内部收益率体现了投资资金的时间价值，是反映项目获利能力的动态评价指标。B、C选项说法正确，一般通过计算内部收益率、已分配收益倍数和总收益倍数等主要指标，与市场中同一年份内同类型基金整体指标情况进行综合比较，以此来确定该基金在当时时点的业绩表现水平，为投资人评价基金的投资效果提供参考。D选项说法错误，内部收益率（IRR）是指截至某一特定时点，倒推计算至基金成立后第一笔现金流产生时，基金资金流入现值加上资产净值现值总额与资金流出现值总额相等，即净现值（NPV）等于零时的折现率。基金某一时点的内部收益率（IRR）与基金存续期满清算后的内部收益率不相同。"
        },
        {
            "title": "股权投资基金运作股权投资业务取得的不同形态资本增值中，需要计缴增值税的是（　　）。",
            "question": "A. 项目股息、分红收入\nB. 通过回购方式退出的项目收入\nC. 通过并购退出的项目收入\nD. 通过二级市场退出的项目收入",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于增值税，以下表述正确的是（　　）。",
            "questions": "I. 增值税属于流转税<br>II. 金融业尚未全面纳入营改增试点范围<br>III. 转让非上市公司股权无需缴纳增值税<br>IV. 项目上市后通过二级市场退出免征增值税",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于内部收益率（IRR），下列说法错误的是（　　）。",
            "question": "A. 内部收益率（IRR）是反映投资基金获利能力的动态财务指标\nB. 基金内部收益率（IRR）可以为投资人评价基金的投资效果提供参考\nC. 基金内部收益率（IRR）指标可以用来对不同基金的业绩进行评价\nD. 基金某一时点的内部收益率（IRR）与基金存续期满清算后的内部收益率是相同的",
            "answer": "D",
            "explain": ""
        }, {
            "title": "根据《上市公司创业投资基金股东减持股份的特别规定》，创业投资基金所投资符合条件的企业是指满足下列情形之一的企业（　　）。",
            "questions": "I. 接受投资当年及下一纳税年度，研发费用总额占成本费用支出的比例不低于20%<br>II. 首次接受投资时，企业成立不满60个月<br>III. 首次接受投资时，企业职工人数不超过500人，根据经审计的年度合并会计报表，年度销售额不超过2亿元，资产不超过2亿元<br>IV. 截至发行申请材料受理日，企业根据《高新技术企业认定管理办法》已取得高新技术企业证书",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、III、IV\nD. I、II、III",
            "answer": "A",
            "explain": "本题考查符合政策的早期中小企业和高新技术企业条件。政策所称早期中小企业，是指创业投资基金首次投资资企业时，该企业符合下列条件："
        },
        {
            "title": "A公司原始股东持有公司77%的股份，B股权投资基金持有公司23%的股份，现X公司股受让A公司原始股东持有的45%股权，B股权投资基金要求以同等价格及条件转让其持有的23%股权，X公司仅愿意购买A公司45%的股权，根据B股权投资基金和原始股东约定，B股权投资基金有权转让10.35%的股权，原始股东仅能转让34.65%的股权，该交易涉及的投资条款是（　　）。",
            "question": "A. 保护性条款\nB. 随售权条款\nC. 估值调整条款\nD. 拖售权条款",
            "answer": "B",
            "explain": "本题考查随售权条款。随售权是指目标公司的其他股东敌对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。故本题选B选项。"
        },
        {
            "title": "甲、乙、丙三人共同出资500万元设立了一个有限责任公司，其中甲和乙各出资40%，丙出资20%。该公司章程的下列条款中，不符合公司法律制度规定的是（　　）。",
            "question": "A. 股东会表决时，甲、乙、丙按照出资比例行使表决权\nB. 股东会表决选举公司董事和总经理时，须经甲、乙、丙一致同意，决议方为通过\nC. 公司分配利润时，甲、乙、丙按实缴的出资比例分配\nD. 公司解散清算后，如有剩余财产，甲、乙、丙按照出资比例分配",
            "answer": "B",
            "explain": "本题考查公司的决议。A项正确，股东会会议由股东按照出资比例行使表决权，但是公司章程另有规定的除外。B项错误，决定聘任或者解聘公司经理及其报酬事项是董事会的职权。C项正确，公司弥补亏损和提取公积金后所余税后和同在分配时，通常在有限责任公司型基金的股东中按照实缴的出资比例分配，或在股份有限公司型基金的股东中披照股东持有的股份比例分配。不过，若通过全体股东约定或股份有限公司章程规定，则可以突破前述常规安排。"
        },
        {
            "title": "关于对被投资企业的投后期管理，以下表述正确的是（　　）。",
            "questions": "I. 被投资企业是相对成熟的企业，应侧重关注其业绩指标，例如市场占有率、收入规模等<br>II. 被投资企业是初创型企业，应关注其成长性，应尽快扭亏为盈<br>III. 被投资企业更换审计机构，可能预示着问题即将发生，甚至已经发生，应重点关注<br>IV. 被投资企业的财务比率指标不能一概而论，应综合考虑各个行业的特性",
            "question": "A. II、III、IV\nB. I、II\nC. I、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "本题考查经营指标的侧重点。不同经营情况的被投资企业经营指标监控侧重点不同：业务和市场已相对成熟稳定的企业业绩指标，监控侧重点如收入、净利润、市场占有率等。尚在积极开拓市场的成长型企业成长指标，监控侧重点如网点建设、新市场进入、销售额增长等。"
        },
        {
            "title": "关于股权投资母基金，下列说法错误的是（　　）。",
            "question": "A. 只能投资于股权投资基金，不得直接对公司股权进行投资\nB. 通常在股权投资基金募集时对基金进行投资，成为基金投资者\nC. 有时在股权投资基金募集完成后对已有股权投资基金或其投资组合进行投资\nD. 有时会对公司股权进行直接投资",
            "answer": "A",
            "explain": "本题考查股权投资母基金的业务。股权投资母基金的业务包括一级投资，二级投资和直接投资。A选项说法错误，D选项说法正确，直接投资指母基金直接对非公开发行和交易的企业按权进行投资。B选项说法正确，一级投资指母基金在股权投资基金募集时对基金进行投资，成为基金投资者。C选项说法正确，二级投资指母基金在股权投资基金募集设立完成后，对存续基金或其投资组合公司进行投资。"
        },
        {
            "title": "关于估值方法中的清算价值法，表述错误的是（　　）。",
            "question": "A. 一般采用清算价值法，估值时采用较高的折扣率\nB. 清算价值法，常见于杠杆收购和破产投资策略\nC. 采用清算价值法应进行市场调查，收集与被评估资产或类似资产清算拍卖相关的项目价格资料\nD. 对股权投资基金而言，企业在正常可持续经营情况下，一般不会采用清算价值法",
            "answer": "A",
            "explain": "本题考查清算价值法的相关知识。A选项说法错误，清算价值法常见于杠杆收购和破产投资策略。一般采用清算价值法估值时采用较低的折扣率。"
        }, {
            "title": "某投资者经测评为风险承受能力最低类别的普通投资者，除因遗产继承等特殊原因产生的基金份额转让之外，其可购买的基金产品为（　　）级。",
            "question": "A. R3\nB. R1\nC. R4\nD. R2",
            "answer": "B",
            "explain": "本题考查投资者适当性匹配的原则。除因遗产继承等特殊原因产生的基金份额转让之外，普通投资者主动购买高于其风险承受能力基金产品或者服务的行为，不得突破相关准入资格的限制。"
        },
        {
            "title": "关于私人股权，以下表述错误的是（　　）。",
            "question": "A. 包括未上市企业和上市企业非公开发行和交易的普通股\nB. 包括未上市企业和上市企业非公开发行和交易的可转换债券\nC. 包括未上市企业和上市企业非公开发行和交易的公司债\nD. 包括未上市企业和上市企业非公开发行和交易的依法可转换为普通股的优先股",
            "answer": "C",
            "explain": "本题考查私人股权的含义。私人股权包括未上市企业和上市企业非公开发行和交易的普通股(A选项)、依法可转换为普通股的优先股(D选项)和可转换债券(B选项)。C选项说法错误，私人股权不包括未上市企业和上市企业非公开发行和交易的公司债。"
        },
        {
            "title": "关于股权投资基金中的市场服务机构，以下表述错误的是（　　）。",
            "question": "A. 基金投资者有权参与选择承办基金审计业务的审计机构\nB. 基金财产保管机构仅承担保管责任，不同于基金托管机构承担的相关责任\nC. 律师协助清算主体制定清算方案\nD. 为保障投资者合法权益，必须由基金管理人办理基金份额登记",
            "answer": "D",
            "explain": "本题考查股权投资基金服务机构内容。A选项说法正确，投资者可以参与选择承办基金审计业务的审计机构，基金管理人应将基金的审计机构的委任情况及时告知投资者。B选项说法正确，基金资产保管机构作为基金管理人的代理人，对基金资产承担保管责任。基金托管机构对投资者承担双重受托责任。C选项说法正确，律师服务涵盖股权投资基金的各个阶段，包括设立、投资、管理、项目退出以及清算等，在清算阶段，可协助清算主体制订清算方案。"
        },
        {
            "title": "某机构投资了某大型餐饮集团，近日该餐饮集团遭媒体曝光出现后厨地上老鼠乱窜，打扫卫生的簸箕和餐具同池混洗，用顾客使用的火锅漏勺掏下水道等问题，该餐饮集团第一时间进行了调研并发布了道歉声明。该机构投资经理对该事件持续关注及跟踪，下列表述正确的是（　　）。",
            "question": "A. 属于对公司经营风险控制情况的跟踪与监控\nB. 属于对公司治理情况的跟踪与监控\nC. 属于对公司危机事件处理情况的跟踪与监控\nD. 属于对公司战略与业务发展定位的跟踪与监控",
            "answer": "C",
            "explain": "本题考查项目跟踪与监控中需要重点关注的管理事项。A选项，公司经营风险是被投资企业日常管理中应注意的问题，而题干所述的被曝光“后厨老鼠同池混洗”等，不是天天发生的日常事件，故A选项不符合题意。"
        },
        {
            "title": "关于募集机构的责任和义务，表述错误的是（　　）。",
            "question": "A. 采取委托募集的，不能豁免基金管理人依法应承担的责任\nB. 采取委托募集的，基金投资者应保证募集行为合法合规\nC. 采取自行募集的，基金管理人应保证募集行为合法合规\nD. 采取委托募集的，受托的第三方代销机构承担募集行为合法合规的责任和义务",
            "answer": "B",
            "explain": "本题考查募集机构的责任和义务。A选项说法正确，委托募集并不能豁免基金管理人依法应承担的责任。B选项说法错误，D选项说法正确，基金管理人应当委托具有合格基金销售资质和专业基金销售服务团队的机构代为募集，并与代销机构签署书面协议，要求其严格遵守合格投资者制度和募集规定，履行对投资者的评估和投资者风险确认程序。所以受托的第三方代销机构承担有保证募集行为合法合规的责任和义务，而不是基金投资者。"
        },
        {
            "title": "股权投资基金进行业务尽职调查时，针对市场的调查范畴通常不包括（　　）。",
            "question": "A. 供应商及经销商\nB. 竞争对手\nC. 销售费用预算\nD. 产业政策",
            "answer": "C",
            "explain": "本题考查业务尽职调查。业务尽职调查的市场内容包括：（1）企业所属的行业分类；（2）相关的产业政策（D选项）；（3）竞争对手（B选项）。"
        }, {
            "title": "关于私募基金管理人内部控制指引的目标，错误的是（　　）。",
            "question": "A. 推动私募基金行业规范发展\nB. 引导私募基金管理人加强内部控制\nC. 保证私募基金管理人合法合规，诚信经营\nD. 提高私募基金管理人风险防范能力",
            "answer": "A",
            "explain": "本题考查内部控制指引的目标。A选项表述错误，内部控制指引的目标是对管理人进行内部控制，不涉及行业规范发展。B、C、D选项表述正确，股权投资基金管理人内部控制是指，股权投资基金管理人为防范和化解风险，保证各项业务的合法合规运作，实现经营目标，在充分考虑内外部环境的基础上，对经营过程中的风险进行识别、评价和管理的制度安排、组织体系和控制措施。"
        },
        {
            "title": "关于投资协议中竞业禁止条款，下列表述错误的是（　　）。",
            "question": "A. 确保其董事或其他高管不得兼职与本公司业务有竞争的职位\nB. 条款目的是为了保证目标公司的利益不受损害，从而保障投资人的利益\nC. 关键员工不得在离职后一段时期内加入与本公司有竞争关系的公司\nD. 要求目标公司通过口头承诺方式进行约定",
            "answer": "D",
            "explain": "本题考查竞业禁止条款的内容。A、C选项说法正确，D选项说法错误，竞业禁止条款是指在投资协议中，股权投资基金为了确保目标公司的良好发展和利益，要求目标公司通过保密协议或其他方式，确保其董事或其他高管不得兼职与本公司业务有竞争的职位，同时，在离职后一段时期内，不得加入与本公司有竞争关系的公司或从事与本公司有竞争关系的业务。(口头承诺方式说法错误) B选项说法正确，竞业禁止条款的目的是为了保证目标公司的利益不受损害，从而保障投资者的利益。"
        },
        {
            "title": "关于基金内部收益率，以下表述错误的是（　　）。",
            "question": "A. 内部收益率往往在基金处于退出期后进行计算\nB. 内部收益率为净现值等于零时的折现率\nC. 内部收益率计算公式中，Cn为每年现金流，只包含正现金流\nD. 内部收益率体现了投资资金的时间价值",
            "answer": "C",
            "explain": "本题考查内部收益率。C选项说法错误，内部收益率的计算公式为其中，C0，C1，C2，...，Cn为每年的现金流，包含正现金流、负现金流为折现率；NAV一般是以公允价值对未退出项目估值后的净资产。根据内部收益率的定义，当且仅当净现值为0时，r才是该基金在第n年时的内部收益率。"
        },
        {
            "title": "计算截至某一时点的项目投资的内部收益率时，应考虑的必备参数不包括（　　）。",
            "question": "A. 获得项目收益的时间及金额\nB. 对项目出资的时间及金额\nC. 项目公司将资金陆续投入生产经营的时间和金额\nD. 截至计算时点的项目资产净值",
            "answer": "C",
            "explain": "本题考查内部收益率。内部收益率是根据截至某一确定时点基金在存续期内每年的投资经营现金流，以及该时点的资产净值，算回期初净现值等于零时相应的折现率。毛内部收益率是为基金投资项目的内部收益率，相关现金流和资产净值考虑基金层面，考虑参数包括对项目出资的时间及金额、获得项目收益的时间及金额、截至计算时点的项目资产净值。"
        },
        {
            "title": "股权投资基金拟对处于扩张阶段的某目标企业开展业务尽职调查，主要核查的内容包括（　　）。",
            "questions": "I. 重大合同的真实性<br>II. 企业资产的抵押情况<br>III. 企业的中长期发展战略<br>IV. 管理团队的薪酬与股权激励<br>V. 企业的产品生产与销售情况",
            "question": "A. II、III、IV\nB. I、II、III、V\nC. I、II、III\nD. III、IV、V",
            "answer": "D",
            "explain": "本题考查业务尽职调查。扩张期企业业务尽职调查重点包括管理团队、产品服务、发展战略及市场因素。"
        },
        {
            "title": "关于创业投资基金与并购基金，以下表述正确的是（　　）。",
            "question": "A. 两者都采取控股性投资\nB. 两者的投资对象都包括成熟阶段企业\nC. 两者通常都使用杠杆\nD. 两者的投资方式都是对被投资企业进行增资",
            "answer": "B",
            "explain": "本题考查创业投资基金与并购基金的特点。A选项说法错误，创业投资基金通常采取参股性投资；并购基金主要采取控股性投资。B选项说法正确，创业投资基金主要是早期、中期、后期（成熟阶段）各个发展阶段的未上市成长性企业；并购基金主要投向成熟企业。C选项说法错误，创业投资基金一般不借助杠杆；并购基金往往借助于杠杆。D选项说法错误，创业投资基金主要以增资的方式投资于目标公司；并购基金主要以购买存量股权的方式对目标公司进行投资。"
        }, {
            "title": "某基金在募集过程中达到了投资者人数的限制，但募集金额仍未达到预定募集金额，应（　　）。",
            "question": "A. 通过募集以基金份额为投资标的的金融产品帮助更多投资者进行投资\nB. 通过将基金份额或收益权进行拆分转让，帮助更多投资者进行投资\nC. 停止募集，不再扩大基金规模",
            "answer": "C",
            "explain": "本题考查明确合格投资者标准的内容。股权投资基金应当向合格投资者募集，单位或个人不得为规避合格投资者标准，募集以股权投资基金份额或其收益权为投资标的的金融产品，或者将股权投资基金份额或其收益权进行非法拆分转让，变相突破合格投资者标准。"
        },
        {
            "title": "关于合伙型基金，表述正确的是（　　）。",
            "question": "A. 基金是独立企业，应缴纳企业所得税\nB. 有限合伙人通常以投资决策委员会成员参与投资决策\nC. 普通合伙人可以通过自我管理或者委托其他基金管理人负责基金投资等重大事项的管理与决策\nD. 主要参与主体有合伙人、基金管理人以及基金托管人",
            "answer": "C",
            "explain": "本题考查合伙型基金内容。A选项说法错误，按照我国税法，有限合伙企业不是企业所得税的纳税主体，而是由合伙人承担纳税义务。B选项说法错误，有限合伙人不参与投资决策，不执行合伙事务，对外不可以代表合伙企业。C选项说法正确，普通合伙人可自行担任基金管理人或者委托专业的基金管理机构担任基金管理人，负责基金投资等重大事项的管理与决策。D选项说法错误，合伙型基金的参与主体包括普通合伙人、有限合伙人和基金管理人。"
        },
        {
            "title": "第一拒绝权条款作为股东权利，通常在公司（　　）的股权被出售时触发。",
            "questions": "I. 创始股东<br>II. 董事会成员股东<br>III. 公司高管股东<br>IV. 监事会成员股东",
            "question": "A. I、II、IV\nB. II、III、IV\nC. I、II、III、IV\nD. I、III、IV",
            "answer": "C",
            "explain": "本题考查第一拒绝权的概念。第一拒绝权，是指目标公司的其他股东（I、II、III、IV项均属于其他股东）欲对外出售股权时，作为老股东的股权投资基金在同等条件下有优先购买权。"
        },
        {
            "title": "股权投资基金A现拟对目标公司B进行法律尽职调查，以下表述正确的是（　　）。",
            "question": "A. 法律尽职调查的作用是帮助基金A评估公司B资产和业务的合法性及潜在的法律风险\nB. 基金A的尽职调查人员在法律尽职调查中需要发现并分析公司B业务各方面问题\nC. 法律尽职调查人员可以针对公司B的调查工作出具最终法律意见，但不能作为准备交易文件的重要依据\nD. 基于法律尽职调查所需的专业角度，基金A必须聘请职业的外部律师团队进行尽职调查工作",
            "answer": "A",
            "explain": "本题考查法律尽职调查。A项正确，B项错误，法律尽职调查的作用是帮助股权投资基金全面评估企业资产和业务的合法性以及潜在的法律风险。C项错误，法律尽职调查的内容主要有出具法律意见并将之作为准备交易文件的重要依据。D项错误，基金可以（而非必须）聘请职业的外部律师团队进行尽职调查工作。"
        },
        {
            "title": "关于股权投资基金中的市场服务机构，以下表述错误的是（　　）。",
            "question": "A. 基金财产保管机构承担保管责任，不同于基金托管机构承担的受托责任\nB. 律师服务涵盖股权投资基金的各个阶段，包括设立、投资、管理、项目退出以及清算等\nC. 为保障投资者的合法权益，必须由基金管理人办理基金份额登记\nD. 基金投资者有权参与选择承办基金审计业务的审计机构",
            "answer": "C",
            "explain": "A选项说法正确，基金资产保管机构作为基金管理人的代理人，对基金资产承担保管责任。基金托管机构对投资者承担双重受托责任。B选项说法正确，律师服务涵盖股权投资基金的各个阶段，包括设立、投资、管理、项目退出以及清算等。C选项说法错误，基金管理人可以办理其募集基金的份额登记业务，也可以委托基金份额登记机构代为办理基金份额登记业务。D选项说法正确，投资者可以参与选择承办基金审计业务的审计机构，基金管理人应将基金的审计机构的委任情况及时告知投资者。"
        },
        {
            "title": "下述哪个机构可以接受股权投资基金管理人的委托成为募集机构（　　）。",
            "question": "A. 具有基金销售业务资格的中国证监会会员的基金销售公司\nB. 具有资产管理资格的中国证监会会员的资产管理公司\nC. 具有资产管理资格的中国证券投资基金业协会会员的资产管理公司\nD. 具有基金销售业务资格的中国证券投资基金业协会会员的基金销售公司",
            "answer": "D",
            "explain": "本题考查销售机构应当具备的资质条件。基金销售机构参与股权投资基金募集活动需要满足：（1）在中国证监会注册取得基金销售业务资格；（2）成为中国证券投资基金业协会会员；（3）接受基金管理人委托（签署销售协议）。A、B、C选项不符合题意，D选项符合题意。"
        }, {
            "title": "使用一般价值等式进行计算，从“企业价值”推算“归属于母公司股东的股权价值”需要考虑的因素包括（　　）。",
            "questions": "I. 非核心资产价值<br>II. 债务<br>III. 少数股东权益<br>IV. 现金",
            "question": "A. III、IV\nB. II、III、IV\nC. I、II\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查一般价值等式。一般价值等式为：企业价值+非核心资产价值+现金=债务+少数股东权益+归属于母公司股东的股权价值。综上，I、II、III、IV项均符合题意。"
        },
        {
            "title": "关于投资协议中董事会席位条款以下表述正确的是（　　）。",
            "question": "A. 董事会席位的数量由中小股东投票决定\nB. 投资方持股达到50%以上才有权提名若干名董事\nC. 根据此条款目标企业可进行控制权分配，保护彼此利益\nD. 可约定目标企业董事会的席位数量且后续不能调整",
            "answer": "C",
            "explain": "本题考查董事会席位条款的定义。董事会席位条款指的是在投资协议中股权投资基金和目标公司之间约定董事会的席位构成和分配的条款，约定目标企业董事会的席位数量，初始分配方案和后续调整规则。由上述定义可知，A选项表述错误，董事会席位的数量由股权投资基金和目标公司约定，而不是由中小股东投票决定。B选项表述错误，董事会分配方案由股权投资基金和目标公司约定，并没有条件要求。C选项表述正确，董事会是公司治理的重要组成部分，董事会席位条款的实质是对被投资企业的控制权分配进行约定，可以保护彼此利益。"
        },
        {
            "title": "清算组在做告债权人申报债权的同时，应当调查和清理公司的财产。根据债权人的申请和调查清理的情况编制相应报表，这些报表不包括（　　）。",
            "question": "A. 资产负债表\nB. 财产清单\nC. 债权、债务目录\nD. 现金流量表",
            "answer": "D",
            "explain": "本题考查清算的相关内容。清算组在通告债权人申报债权的同时，应当调查和清理公司的财产。根据债权人的申请和调查清理的情况编制公司资产负债表、财产清单和债权、债务目录，制订清算方案。"
        },
        {
            "title": "某创业投资基金为规避大股东侵害自身利益的风险，要求目标公司在执行对所有者权益构成重大影响的决策前，需征求所有股东的同意，所设置的条款是（　　）。",
            "question": "A. 竞业禁止条款\nB. 保护性条款\nC. 限制性条款\nD. 估值调整条款",
            "answer": "B",
            "explain": "本题考查保护性条款。B选项符合题意，保护性条款是指股权投资基金为保护自身利益而设置的要求目标公司在执行某些可能损害投资者利益或对投资者利益有重大影响的行为时，需取得投资者同意的条款。"
        },
        {
            "title": "对于基金投资者和管理人之间的收益分配，以下属于单一项目分配的是（　　）。",
            "question": "A. 每个投资项目退出后的全部资金，在投资者和管理人之间按约定分配前，需先返还投资人本金和支付优先收益\nB. 每个投资项目退出后的全部资金，在投资人和管理人之间按约定分配，需先返还投资人本金，不必支付优先收益\nC. 每个投资项目退出后的每一笔资金，在投资人和管理人之间按约定分配，不必先返还投资人的全部本金出资和支付优先收益\nD. 每个投资项目退出后的每一笔资金，在投资人和管理人之间按约定分配，需先支付优先收益，不必返还投资人本金",
            "answer": "A",
            "explain": "本题考查单一项目的收益分配方式。流程如下：（1）每个投资项目退出后，退出资金先向投资者分配，直至分配金额达到投资者针对该退出部分对应的投资本金（排除D选项）。（2）剩余资金向基金投资者分配，用于弥补之前已处置的项目产生的投资亏损金额。（3）剩余资金继续向基金投资者分配，直至基金投资者获得截至分配时点已收回的投资本金及门槛收益率计算的门槛收益（排除B、C选项）。（4）最后的剩余资金（若有追赶机制，则剩余资金先向基金管理人进行分配，直至基金管理人获得已分配门槛收益部分对应的业绩报酬）按照约定的分配比例，在基金管理人和基金投资者之间进行分配。"
        },
        {
            "title": "股权投资基金的收益分配原则有（　　）。",
            "questions": "I. 首先向投资者返还投资本金<br>II. 其次向投资者支付约定的门槛收益<br>III. 剩余收益按照约定的比例在管理人和投资者之间进行分配<br>IV. 剩余收益按照约定的比例在管理人和托管人之间进行分配",
            "question": "A. II、III\nB. I、II、IV\nC. I、II、III、IV\nD. I、II、III",
            "answer": "D",
            "explain": "本题考查股权投资基金的收益分配原则。股权投资基金的收益分配原则如下：（1）首先向投资者返还投资本金；（2）其次向投资者支付约定的门槛收益；（3）剩余收益按照约定的比例在管理人和投资者之间进行分配。"
        }, {
            "title": "股权投资基金管理人应当向投资者进一步声明，中国基金业协会为股权投资基金管理人和股权投资基金办理登记备案不构成对（　　）。",
            "question": "A. 股权投资基金管理人投资能力、持续盈利情况的认可;不作为对基金财产安全的保证\nB. 股权投资基金管理人投资能力、持续合规情况的认可;但作为对基金财产安全的保证\nC. 股权投资基金管理人投资能力、持续合规情况的认可;不作为对基金财产安全的保证\nD. 股权投资基金管理人投资能力、持续盈利情况的认可;但作为对基金财产安全的保证",
            "answer": "C",
            "explain": "股权投资基金管理人应当向投资者进一步声明，中国证券投资基金业协会为股权投资基金管理人和股权投资基金办理登记备案不构成对股权投资基金管理人投资能力、持续合规情况的认可;不是对基金财产安全的保证。"
        },
        {
            "title": "国内股权投资交易中，估值调整的一般原因包括（　　）。",
            "question": "A. 担心投资后目标公司的董事会成员进行换届变动\nB. 担心投资后目标公司的团队未能好好运营达到设定的业绩目标\nC. 担心投资后目标公司的办公地址进行变迁\nD. 担心投资后目标公司的组织架构根据需要进行变动",
            "answer": "B",
            "explain": "为了保护投资者利益，股权投资基金有时在股权投资协议中约定估值调整条款。在股权投资中比较常见的安排包括对赌安排，即在一定期限之后企业未能完成一定指标、投资者会获得一定补偿，以弥补其由于企业的实际价值降低所受的损失。"
        },
        {
            "title": "以下不属于基金出现清算退出原因的是（　　）。",
            "question": "A. 基金存续期届满\nB. 基金份额持有人大会（股东大会或者全体合伙人）决定进行基金清算\nC. 全部投资项目都已经清算退出，且按照约定基金管理人决定不再进行重复投资\nD. 部分投资项目都已经清算退出",
            "answer": "D",
            "explain": "一般地，股权投资基金清算的原因有以下几种：（1）基金合同约定的存续期届满；（2）基金全部投资项目都已经实现清算退出，且按照约定基金管理人决定不再进行重复投资；"
        },
        {
            "title": "下列不属于股权投资基金的投资后管理的是（　　）。",
            "question": "A. 参与被投资企业的管理\nB. 提供各项围绕企业发展的增值服务\nC. 对被投资企业实施项目监控\nD. 以被投资企业为案例进行下一基金募资",
            "answer": "D",
            "explain": "投资后管理，是指股权投资基金与被投资企业投资交割之后，基金管理人积极参与被投资企业的管理，对被投资企业实施项目监控并提供各项增值服务的一系列活动。"
        },
        {
            "title": "关于股权投资基金管理人的职责，以下说法错误的是（　　）。",
            "question": "A. 严格按照基金投资策略进行投资运作，并对被投企业进行投后管理\nB. 尊重股权投资基金商,应获得中国证券投资基金业协会行政审批\nC. 为被投企业提供企业战略规划、企业治理水平提升等增值服务\nD. 定期向基金投资者呈报基金财务报告",
            "answer": "B",
            "explain": "我国目前股权投资基金只能非公开募集，基金管理人无须中国证监会行政审批，而实行登记制度，只需向中国证券投资基金业协会登记即可。"
        },
        {
            "title": "根据《合伙企业法》等相关规定，合伙企业生产经营所得和其他所得采取（　　）。",
            "question": "A. “先税后分”\nB. “先分后税”\nC. 按股权比例分配\nD. 按固定比例分配",
            "answer": "B",
            "explain": "根据《合伙企业法》等相关规定，合伙企业生产经营所得和其他所得采取“先分后税”的原则。"
        },
        {
            "title": "政府引导基金本身（　　）从事创业投资业务。",
            "question": "A. 直接\nB. 不直接\nC. 前两者都可以\nD. 前两者都不可以",
            "answer": "B",
            "explain": "政府引导基金本身不直接从事创业投资业务。"
        },
        {
            "title": "根据《外商投资创业投资企业管理规定》，下列关于必备投资者的说法中，错误的是（　　）。",
            "question": "A. 以创业投资为主营业务\nB. 外商投资创业投资企业的所有投资者应符合必备投资者的要求\nC. 配备具有一定创业投资从业经验的人员\nD. 具备一定资金实力和投资经验",
            "answer": "B",
            "explain": "《外商投资创业投资企业管理规定》规定，设立外商投资创业投资企业，应至少拥有一个“必备投资者”。根据规定，“必备投资者”应当是具备创业投资专业能力与资金实力的投资者，并非所有投资者。其余选项均表述正确。"
        },
        {
            "title": "关于投资协议常见条款，以下表述错误的是（　　）。",
            "question": "A. 反摊薄条款的实质是一种价格保护机制\nB. 反摊薄条款适用于后轮融资为降价融资时的情况\nC. 股权投资基金可通过董事会席位条款约定委派人员出任董事会观察员\nD. 董事会席位条款又称保护性条款",
            "answer": "D",
            "explain": "董事会席位条款和保护性条款是两个不同的条款。"
        },
        {
            "title": "股权投资基金管理人和托管人发生重大事项变更，股权投资基金发生触及基金止损线或者预警线、管理费率或者托管费率变更、清盘或者清算、重大关联交易、提取业绩报酬等影响投资者利益的重大事项的，信息披露义务人应当在（　　）个工作日内向投资者披露。",
            "question": "A. 1\nB. 3\nC. 5\nD. 10",
            "answer": "D",
            "explain": "股权投资基金管理人和托管人发生重大事项变更，股权投资基金发生触及基金止损钱或者预警线、管理费率或者托管费率变更、清盘或者清算、重大关联交易、提取业绩报酬等影响投资者利益的重大事项的，信息披露义务人应当在10个工作日内向投资者披露。"
        },
        {
            "title": "关于政府引导基金的宗旨或特征，以下表述错误的是（　　）。",
            "question": "A. 追求收益最大化，缓解财政收入增长乏力问题\nB. 克服单纯通过市场配置创业投资资本的市场失灵问题\nC. 促进落实本地产业政策和新兴产业规划\nD. 促进本地的早期投资与创新创业进步发展",
            "answer": "A",
            "explain": "政府引导基金的宗旨是发挥财政资金的引导和聚集放大作用，引导民间投资等社会资本投入，增加创业投资资本的供给，克服单纯通过市场配置创业投资资本的市场失灵问题，特别是通过激励创业投资基金投资处于种子期、起步期等创业早期的企业，弥补一般创业投资基金主要投资于成长期、成熟期和重建期企业的不足。"
        },
        {
            "title": "股权投资基金为被投资企业提供增值服务，以下表述错误的是（　　）。",
            "question": "A. 对于发展较为成熟的被投资企业，增值服务侧重在资源导入、兼并收购、上市推动等方面\nB. 对于早期阶段的被投资企业，增值服务侧重在规范管理、业务开拓、后续再融资等方面\nC. 主要目的是提升被投资企业的价值，降低投资风险，最终实现投资机构对被投资项目的顺利退出\nD. 协助被投资企业进行后续再融资工作，以便投资机构能够参与被投资企业的后续轮次融资",
            "answer": "D",
            "explain": "对于早期阶段的被投资企业，投资机构侧重于协助其进行规范管理、业务开拓、后续再融资等，而对于发展较为成熟的被投资企业，投资机构提供增值服务的内容往往侧重于资源导入、兼并收购、上市推动等。在当前市场环境下，增值服务能力甚至成为投资机构的核心竞争力。一方面，通过增值服务能协助被投资企业实现更好更快的发展；另一方面，可以有效地降低投资风险。"
        },
        {
            "title": "按资金性质分类，股权投资基金可以分为（　　）。",
            "question": "A. 人民币基金和外币基金\nB. 创业投资基金和并购基金\nC. 一级基金和二级基金\nD. 股权投资母基金和政府引导基金",
            "answer": "A",
            "explain": "按资金性质分类，股权投资基金可以分为人民币基金和外币基金。"
        }, {
            "title": "私人股权投资基金一词中，私人是指（　　）。",
            "question": "A. 仅指基金是私募的\nB. 投资者为非国有或集体所有的机构或个人\nC. 股权是非公开发行和交易，基金是私募的\nD. 仅指股权是非公开发行和交易",
            "answer": "D",
            "explain": "国内所称“股权投资基金”，其全称应为“私人股权投资基金”，是指主要投资于“私人股权”的投资基金。私人股权即非公开发行和交易的股权，包括未上市企业和上市企业非公开发行和交易的普通股、可转换为普通股的优先股和可转换债券。"
        },
        {
            "title": "公司型基金中通过公司章程对公司内部（　　）作出规定。",
            "questions": "I、组织结构设立<br>II、管理权限<br>III、投资管理<br>IV、利益分配",
            "question": "A. I、III、IV\nB. I、II、IV\nC. I、II、III\nD. II、III、IV",
            "answer": "B",
            "explain": "公司治理结构的基本特点是股东至上。公司型基金中，投资者出资成为公司股东，公司需依法设立董事会（执行董事）、股东大会（股东会）以及监事会（监事），通过公司章程对公司内部组织结构设立、管理权限、利益分配作出规定。"
        },
        {
            "title": "杠杆收购的主要资金来源中，由杠杆收购基金提供的是（　　）。",
            "question": "A. 垃圾债券\nB. 优先股\nC. 银行贷款\nD. 股权资本",
            "answer": "D",
            "explain": "D选项符合题意，股权资本主要由杠杆收购基金提供，采取普通股的形式。"
        },
        {
            "title": "某股权投资基金管理人拟向高净值个人投资者募集一只股权投资基金，投资者预计不少于70名为避免企业所得税双重纳税，不考虑其他因素的情况下，建议其设立的基金形式为（　　）。",
            "question": "A. 有限责任公司型\nB. 有限合伙型\nC. 信托（契约）型\nD. 股份有限公司型",
            "answer": "C",
            "explain": "合伙型基金、信托（契约）型基金能够避免双重纳税，合伙型基金应由2个以上50个以下合伙人设立（70名投资者超出了合伙型基金的人数限制）。"
        },
        {
            "title": "关于未上市企业股权的非公开协议转让，以下表述错误的是（　　）。",
            "question": "A. 当企业发展到一定阶段，被投资企业股东对企业未来的潜力看好，也可以通过协商主动回购股权投资基金持有的股权而使股权投资基金实现退出\nB. 股权回购是就通常由被投资企业大股东或创始股东、管理层、员工等出资购买股权投资基金持有的股份，从而使股权投资基金实现退出\nC. 协议转让形式包括并购和回购\nD. 股权投资基金向目标公司投资后，其他收购方购买股权投资基金所持目标公司的部分股权，股权投资基金通过这种形式的退出不属于并购退出",
            "answer": "D",
            "explain": "A选项说法正确，当企业发展到一定阶段，被投资企业股东对企业未来的潜力看好，也可以通过协商主动回购股权投资基金持有的股权而使股权投资基金实现退出。B选项说法正确，股权回购是指通常由被投资企业大股东或创始股东、管理层、员工等出资购买股权投资基金持有的企业股份，从而使股权投资基金实现退出的行为。"
        },
        {
            "title": "股权投资基金的财务尽职调查工作通常启动时点为（　　）。",
            "question": "A. 投资人签署对目标公司的投资协议后\nB. 投资人完成目标公司估值后\nC. 投资人初次接触目标公司时\nD. 投资人与目标公司达成初步合作意向后",
            "answer": "D",
            "explain": "一般是指投资人在与目标企业达成初步合作意向后，经协商一致，对目标企业的一切与本次投资相关的事项进行现场调查、资料分析的一系列活动。"
        }, {
            "title": "关于门槛收益率，下列表述正确的是（　　）。",
            "question": "A. 门槛收益率是指基金向全体投资者返还投资本金后，向基金管理人进行分配直至管理人获得按照门槛收益率计算的投资回报，作为业绩报酬激励基金管理人\nB. 如果基金约定了门槛收益率条款，那么基金在分配时除向全体基金投资者返还投资本金外，还应继续向其进行分配直至其获得门槛收益，之后才开始向基金管理人分配业绩报酬\nC. 为了保持基金管理人与基金投资者之间的利益一致性及基金运营的合规性，基金需要强制设定相应的门槛收益率\nD. 该基金投资者应获得的门槛收益为20亿元",
            "answer": "B",
            "explain": "本题考查门槛收益率的内容。"
        },
        {
            "title": "假设该基金收益分配条款中未设定追赶机制，则基金管理人与基金投资者获得的分配金额分别为（　　）。",
            "question": "A. 基金管理人可分得金额为1.84亿元，全体基金投资者可分得金额为38.16亿元\nB. 基金管理人可分得金额为0.72亿元，全体基金投资者可分得金额为19.28亿元\nC. 基金管理人可分得金额为0.72亿元，全体基金投资者可分得金额为39.28亿元\nD. 基金管理人可分得金额为1.84亿元，全体基金投资者可分得金额为18.16亿元",
            "answer": "C",
            "explain": "本题考查基金收益分配。基金收益分配顺序：(1)向投资者返还投资本金20亿元，剩余金额40-20=20（亿元）；"
        },
        {
            "title": "假设该基金收益分配条款中设有追赶机制，则基金管理人与基金投资者获得的分配金额分别为（　　）。",
            "question": "A. 基金管理人可分得金额为1.87亿元，全体基金投资者可分得金额为38.13亿元\nB. 基金管理人可分得金额为2.00亿元，全体基金投资者可分得金额为18.00亿元\nC. 基金管理人可分得金额为2.00亿元，全体基金投资者可分得金额为38.00亿元\nD. 基金管理人可分得金额为1.87亿元，全体基金投资者可分得金额为18.13亿元",
            "answer": "C",
            "explain": "本题考查基金收益分配。基金收益分配顺序："
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/smgq-5.js